import React, { useEffect, useRef, useState } from "react";
import "./ModelSettings.css";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import { ModelsNamesCompany, ParameterTypes } from "../../../../Helper";
import { useGetDefaultParameterForModel, useUpadteAllDefaultParameters} from "../../../../store/Apis/ModelSettingsApi";
import { setShowPlansModal, setShowSignPopup,  setSnackBarAlert,} from "../../../../store/one-query/chatsSlice";
import ModelSettingsPopupCancel from "./ModelSettingsPopupCancel";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
interface PropsType {
  selectedModel: string;
  params: ParameterTypes | undefined;
  ResetApplyAllModels: (flag: boolean) => void;
  handleClose: () => void;
  applyallModels: boolean;
}
const ModelParameter = ({
  selectedModel,
  params,
  ResetApplyAllModels,
  applyallModels,
  handleClose
}: PropsType) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const GetDefaultParameterForModel = useGetDefaultParameterForModel();
  const UpdateModelSettingsDefault = useUpadteAllDefaultParameters();
  const versionData = useAppSelector((s) => s?.conversationVersion?.data);
  const User = useAppSelector((s)=> s.User)
  const [modelName, modelTitle] = selectedModel.split(" & ");
  const [parameterValues, setParameterValues] = useState<ParameterTypes | undefined>();
  const applyRef = useRef<HTMLButtonElement>(null);
  const [isClickingCancel, setIsClickingCancel] = useState<boolean>(false);

  const saveSuccessCancelPopupState = useAppSelector(
    (s) => s.ModelSettings.saveSuccessCancelPopupState
  );

  const modelId = versionData?.find(
     (version) => version.title === modelTitle
  )?.id;

  useEffect(()=>{
    if (params) setParameterValues(params);
  },[params])

  useEffect(() => {
    if (saveSuccessCancelPopupState) handleClose();
  }, [saveSuccessCancelPopupState]);

  const getKeyFromValue = (value: string): string | undefined => {
    const index = Object.values(ModelsNamesCompany).indexOf(value);
    return index !== -1 ? Object.keys(ModelsNamesCompany)[index] : undefined;
  };

  const modelKey = getKeyFromValue(modelName);

  const handleApplyAllModels = () => {
    ResetApplyAllModels(!applyallModels);
  };

  const handleParameterValues = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    let value = parseFloat(event.target.value);
    const name = event.target.name;
    setParameterValues ((prevData:any)=>
       ({ ... prevData,
      [name]: isNaN(value) ? 0.0 : value}) 
  )};

  const handleResetParameterForModel = () => {
    if(!User.IsAuthenticated){
      handleClose();
      dispatch(setShowSignPopup({show: true , type: "Model settings" , message: "To edit in model settings you need to sign in",btnTitle:"Sign In for Free",btnAction:"NavigateToLogin"}));
    }
    else{
    if (modelKey && modelTitle && modelId) {
      GetDefaultParameterForModel(modelKey || "", modelTitle, modelId);
      ResetApplyAllModels(false);
      dispatch(
        setSnackBarAlert({
          show: true,
          message: "Model settings have been successfully reset",
          alertType: "success",
        })
      );
    }}
  };

  const handleSaveChanges = (SaveChangesFlag: boolean) => {
    if (SaveChangesFlag && applyRef.current) {
      applyRef.current.click();
    }
  };

  const handleCancelChanges = () => {
    if (parameterValues === params) handleClose();
    else setIsClickingCancel(true);
  };

  const handleOpenUpgradePlans = () => {
    dispatch(setShowPlansModal(true));
    
  }

  const handleApplyModelSetting = () => {
    if(!User.IsAuthenticated){
        handleClose();
        dispatch(setShowSignPopup({show: true , type: "Model settings" , message: "Exclusive Feature for Premium Users! "
          ,btnTitle:"Sign In for Free",btnAction:"NavigateToLogin"}));
    } else if (User.IsAuthenticated && !User.isSubscribed){
        handleClose();
        dispatch(setShowSignPopup({show: true , type: "Model settings" , message: "Exclusive Feature for Premium Users! "
          ,btnTitle:"Go Premium",btnAction:"OpenUpgradePlans"}));
    } else {
      if (modelId&& parameterValues)
        UpdateModelSettingsDefault({
          modelId,
          selectedModel,
          applyToAll: applyallModels,
          defaultTemperature: parameterValues?.temperatureCurrentValue,
          defaultMaxToken:  parameterValues?.maxTokenCurrentValue,
          defaultTopP:  parameterValues?.topPCurrentValue,
          defaultFrequency:  parameterValues?.frequencyCurrentValue,
          defaultPresencePenalty:  parameterValues?.presencePenaltyCurrentValue,
        });
    }
  }

  const renderTooltip = (ParameterDes: string) => (props: any) =>
    (
      <Tooltip className="parameter-description-tooltip" {...props}>
        {ParameterDes}
      </Tooltip>
    );

  return (
    selectedModel &&
    parameterValues && (
      <>
        <div className="reset" onClick={handleResetParameterForModel}>
          Reset
        </div>
        <div className="ms-3 me-3 params-container ">
          <div className="mb-2">
            <div className="d-flex justify-content-between mb-2 parameter-container">
              <div className="parameter-label">
                Temperature
                <div className="parameter-description mt-1">
                  Controls the randomness of the output.
                </div>
              </div>
              <div>{parameterValues?.temperatureCurrentValue}</div>
            </div>
            <input
              type="range"
              className="slider"
              name="temperatureCurrentValue"
              min={parameterValues?.temperatureMinValue}
              step="0.1"
              max={parameterValues?.temperatureMaxValue}
              value={parameterValues?.temperatureCurrentValue}
              onChange={handleParameterValues}
              style={{
                background: `linear-gradient(to right, rgba(18, 182, 234, 1) ${
                  (parameterValues?.temperatureCurrentValue /
                    parameterValues?.temperatureMaxValue) *
                  100
                }%, var(--A-background48) ${
                  (parameterValues?.temperatureCurrentValue /
                    parameterValues?.temperatureMaxValue) *
                  100
                }%)`,
              }}
            />
          </div>
          <div className="mb-2">
            <div className="d-flex justify-content-between mb-2 parameter-container">
              <div className="parameter-label">
                Maximum Tokens
                <div className="parameter-description mt-1">
               Limits the length of the response.
                </div>
              </div>
              <div>{parameterValues?.maxTokenCurrentValue}</div>
            </div>
            <input
              type="range"
              className="slider"
              name="maxTokenCurrentValue"
              min={parameterValues?.maxTokenMinValue}
              step="1.0"
              max={parameterValues?.maxTokenMaxValue}
              value={parameterValues?.maxTokenCurrentValue}
              onChange={handleParameterValues}
              style={{
                background: `linear-gradient(to right, rgba(18, 182, 234, 1) ${
                  (parameterValues?.maxTokenCurrentValue /
                    parameterValues?.maxTokenMaxValue) *
                  100
                }%, var(--A-background48) ${
                  (parameterValues?.maxTokenCurrentValue /
                    parameterValues?.maxTokenMaxValue) *
                  100
                }%)`,
              }}
            />
          </div>
          <div className="mb-2">
            <div className="d-flex justify-content-between mb-2 parameter-container">
              <div className="parameter-label">
                Top P
                <div className="parameter-description mt-1">
                  Controls the diversity of the output.
                </div>
              </div>
              <div>{parameterValues?.topPCurrentValue}</div>
            </div>
            <input
              type="range"
              className="slider"
              name="topPCurrentValue"
              min={parameterValues?.topPMinValue}
              step="0.01"
              max={parameterValues?.topPMaxValue}
              value={parameterValues?.topPCurrentValue}
              onChange={handleParameterValues}
              style={{
                background: `linear-gradient(to right, rgba(18, 182, 234, 1) ${
                  (parameterValues?.topPCurrentValue /
                    parameterValues?.topPMaxValue) *
                  100
                }%, var(--A-background48) ${
                  (parameterValues?.topPCurrentValue /
                    parameterValues?.topPMaxValue) *
                  100
                }%)`,
              }}
            />
          </div>
          <div className="mb-2">
            <div className="d-flex justify-content-between mb-2 parameter-container">
              <div className="parameter-label">
                Frequency penalty
                <div className="parameter-description mt-1">
                  Adjusts the likelihood of repeating the same text.
                </div>
              </div>
              <div>{parameterValues?.frequencyCurrentValue}</div>
            </div>
            <input
              type="range"
              className="slider"
              name="frequencyCurrentValue"
              min={parameterValues?.frequencyMinValue}
              step="0.1"
              max={parameterValues?.frequencyMaxValue}
              value={parameterValues?.frequencyCurrentValue}
              onChange={handleParameterValues}
              style={{
                background: `linear-gradient(to right, rgba(18, 182, 234, 1) ${
                  (parameterValues?.frequencyCurrentValue /
                    parameterValues?.frequencyMaxValue) *
                  100
                }%, var(--A-background48) ${
                  (parameterValues?.frequencyCurrentValue /
                    parameterValues?.frequencyMaxValue) *
                  100
                }%)`,
              }}
            />
          </div>
          <div className="mb-2">
            <div className="d-flex justify-content-between mb-2 parameter-container">
              <div className="parameter-label">
                Presence penalty
                <div className="parameter-description mt-1">
                  Encourages new topics in the response.
                </div>
              </div>
              <div>{parameterValues?.presencePenaltyCurrentValue}</div>
            </div>
            <input
              type="range"
              className="slider"
              name="presencePenaltyCurrentValue"
              min={parameterValues?.presencePenaltyMinValue}
              step="0.1"
              max={parameterValues?.presencePenaltyMaxValue}
              value={parameterValues?.presencePenaltyCurrentValue}
              onChange={handleParameterValues}
              style={{
                background: `linear-gradient(to right, rgba(18, 182, 234, 1) ${
                  (parameterValues?.presencePenaltyCurrentValue /
                    parameterValues?.presencePenaltyMaxValue) *
                  100
                }%, var(--A-background48) ${
                  (parameterValues?.presencePenaltyCurrentValue /
                    parameterValues?.presencePenaltyMaxValue) *
                  100
                }%)`,
              }}
            />
          </div>
        </div>
        <div className="d-flex ms-3" style={{marginTop:"16px"}}>
          <input
            type="checkbox"
            className="checkBox"
            checked={applyallModels}
            onChange={handleApplyAllModels}
          />
          <p className="apply-all-text">Apply to all models</p>
        </div>
        <div className="apply-buttons ms-3 me-3" style={{justifyContent:"flex-end"}}>
          <button
            className="CancelDeletePersonaBtn"
            onClick={handleCancelChanges}
          >
            Cancel
          </button>
          <button
            className="createPersonaBtn"
            ref={applyRef}
            onClick={handleApplyModelSetting}
          >
            Apply
          </button>
        </div>
        <div className="cancel-container">
          {isClickingCancel && (
            <ModelSettingsPopupCancel
              handleSetSaveChanges={handleSaveChanges}
              show={isClickingCancel}
              handleClose={() => setIsClickingCancel(false)}
              handleClosePopupParent={handleClose}
            />
          )}
        </div>
      </>
    )
  );
};

export default ModelParameter;
